module.exports = __webpack_public_path__ + "img/logo-pb_l.4d02a5e5.png";